import React  from 'react';
import { Route,Switch} from 'react-router-dom';

import StudentReport from './studentFeesReport';  
 
export  const ReportStudentRoutes = [
    {
        path: '/student-fees-report',
        name:'Student Fees Report',
        component:StudentReport,
        show:true,
    } 
];

const ReportStudent = (props) => {
    return(
        <Switch>
            {ReportStudentRoutes.map((route) => 
                <Route exact
                    key={route.path}
                    path={`${props.match.url}${route.path}`}
                    component={route.component}
                />
            )} 
        </Switch> );
};
export default ReportStudent; 


// WEBPACK FOOTER //
// ./src/components/Reports/StudentReport/index.js